export default __webpack_public_path__ + "static/media/promo-trends-graph-light.070f0b6d.png";